/**
 * @generated SignedSource<<f80931479c9dfccb9cbef6d4a3bf1cb9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type TicketChannel = "manual" | "email" | "phone" | "chat" | "internal" | "api" | "customer_portal" | "direct" | "%future added value";
export type TicketLinkType = "related" | "child" | "project" | "forecast_task" | "%future added value";
export type TicketPriority = "p0" | "p1" | "p2" | "p3" | "%future added value";
export type TicketStatus = "open" | "in_progress" | "waiting_on_customer" | "resolved" | "closed" | "%future added value";
export type CreateTicketInput = {
  subject?: string | null;
  description?: string | null;
  requesterId?: string | null;
  requesterEmail?: string | null;
  status?: TicketStatus | null;
  priority?: TicketPriority | null;
  channel?: TicketChannel | null;
  assigneeId?: string | null;
  labels?: ReadonlyArray<string> | null;
  projectId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type createTicketMutation$variables = {
  input: CreateTicketInput;
  connections: ReadonlyArray<string>;
};
export type createTicketMutation$data = {
  readonly createTicket: {
    readonly clientMutationId: string | null;
    readonly ticketEdge: {
      readonly cursor: string;
      readonly node: {
        readonly id: string;
        readonly slug: string;
        readonly subject: string;
        readonly status: TicketStatus;
        readonly priority: TicketPriority;
        readonly channel: TicketChannel;
        readonly requesterId: string;
        readonly assigneeId: string | null;
        readonly createdAt: string;
        readonly updatedAt: string;
        readonly closedAt: string | null;
        readonly requester: {
          readonly id: string;
          readonly name: string;
          readonly email: string;
        } | null;
        readonly assignee: {
          readonly fullName: string | null;
        } | null;
        readonly labels: ReadonlyArray<{
          readonly id: string;
          readonly name: string | null;
          readonly color: string | null;
        }>;
        readonly links: ReadonlyArray<{
          readonly id: string;
          readonly linkType: TicketLinkType;
          readonly targetProject: {
            readonly id: string;
            readonly name: string;
          } | null;
        }>;
        readonly sla: {
          readonly breached: boolean;
          readonly elapsedSeconds: number;
          readonly thresholdSeconds: number;
          readonly paused: boolean;
        };
      } | null;
    } | null;
  } | null;
};
export type createTicketMutation = {
  variables: createTicketMutation$variables;
  response: createTicketMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientMutationId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subject",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priority",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "channel",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requesterId",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assigneeId",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "closedAt",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "Requester",
  "kind": "LinkedField",
  "name": "requester",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v16/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "Label",
  "kind": "LinkedField",
  "name": "labels",
  "plural": true,
  "selections": [
    (v5/*: any*/),
    (v16/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "TicketLink",
  "kind": "LinkedField",
  "name": "links",
  "plural": true,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "linkType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectLinkTarget",
      "kind": "LinkedField",
      "name": "targetProject",
      "plural": false,
      "selections": [
        (v5/*: any*/),
        (v16/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "TicketSla",
  "kind": "LinkedField",
  "name": "sla",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "breached",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "elapsedSeconds",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "thresholdSeconds",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "paused",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "createTicketMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "CreateTicketPayload",
        "kind": "LinkedField",
        "name": "createTicket",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TicketTypeEdge",
            "kind": "LinkedField",
            "name": "ticketEdge",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Ticket",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v17/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Person",
                    "kind": "LinkedField",
                    "name": "assignee",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "createTicketMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "CreateTicketPayload",
        "kind": "LinkedField",
        "name": "createTicket",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TicketTypeEdge",
            "kind": "LinkedField",
            "name": "ticketEdge",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Ticket",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v17/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Person",
                    "kind": "LinkedField",
                    "name": "assignee",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendEdge",
            "key": "",
            "kind": "LinkedHandle",
            "name": "ticketEdge",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f9541698532c0b755ad5ce0aeb585b14",
    "id": null,
    "metadata": {},
    "name": "createTicketMutation",
    "operationKind": "mutation",
    "text": "mutation createTicketMutation(\n  $input: CreateTicketInput!\n) {\n  createTicket(input: $input) {\n    clientMutationId\n    ticketEdge {\n      cursor\n      node {\n        id\n        slug\n        subject\n        status\n        priority\n        channel\n        requesterId\n        assigneeId\n        createdAt\n        updatedAt\n        closedAt\n        requester {\n          id\n          name\n          email\n        }\n        assignee {\n          fullName\n          id\n        }\n        labels {\n          id\n          name\n          color\n        }\n        links {\n          id\n          linkType\n          targetProject {\n            id\n            name\n          }\n        }\n        sla {\n          breached\n          elapsedSeconds\n          thresholdSeconds\n          paused\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f96dd859524b17cc0610409ac348a386";

export default node;
